import React from 'react'
import ReactDOM from 'react-dom'
import './index.scss'
import App from './App'
import './assets/translation'
import { appRoot } from './assets/dom/domNodes'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  appRoot
)
